const orderRedeemOptions = (redeemOptions) => {
  return redeemOptions || []
}

export default orderRedeemOptions
